<template>
  <div class="flexi-container page__internal page__api">
    <flexi-top-card
      :class="!showHeader ? 'scrolled-up-card' : ''"
      v-view="inView"
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[2].top_card"
      @button-clicked="smoothScroll"
    />

    <flexi-visible when-hidden="#top-card">
      <a @click.prevent="scroll('#top-card')">
        <div class="arrow-down">
          <span class="text" v-text="'Go to top'"></span>
          <div class="svg"></div>
        </div>
      </a>
    </flexi-visible>

    <div class="inview-bg" v-view="inView" />
    <flexi-wrapper
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[2].sections[2]"
    >
      <template v-slot:content="slotProps">
        <div v-text="slotProps.inputData.description" />
        <span class="subtitle">Base URL: https://app.imgforce.com/</span>
      </template>
    </flexi-wrapper>

    <flexi-wrapper
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[2].sections[0]"
    >
      <template v-slot:content>
        <div class="accordion-wrapper">
          <div
            @click="accordion.getImages = !accordion.getImages"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Get all images'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.getImages"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                GET /api/v1/images/get HTTP/1.1
                Host: app.imgforce.com
                Accept: application/json
                Authorization: Bearer {your_token}
                </code>
              </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                {
                  "images": [
                    {
                      "id": 1,
                      "folder_id": 1,
                      "img": "https://app.imgforce.com/images/user/FzZ_1610416853_Akrinum-2.png",
                      "imgName": "FzZ_1610416853_Akrinum-2.png",
                      "extension": "png",
                      "created_at": "2021-01-12T02:00:53.000000Z",
                      "updated_at": "2021-01-12T02:00:53.000000Z",
                      "folder": {
                        "id": 1,
                        "name": "Default",
                        "created_at": null,
                        "updated_at": null
                      }
                    }
                  ],
                  "success": 200
                }
                </code>
              </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>
        <div class="accordion-wrapper">
          <div
            @click="accordion.getSingleImage = !accordion.getSingleImage"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Get single image'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.getSingleImage"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/image/get HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    id={integer}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "image": {
                          "id": 1,
                          "folder_id": 1,
                          "img": "https://app.imgforce.com/images/user/FzZ_1610416853_Akrinum-2.png",
                          "imgName": "FzZ_1610416853_Akrinum-2.png",
                          "extension": "png",
                          "created_at": "2021-01-12T02:00:53.000000Z",
                          "updated_at": "2021-01-12T02:00:53.000000Z",
                          "folder": {
                              "id": 1,
                              "name": "Default",
                              "created_at": null,
                              "updated_at": null
                          }
                      },
                      "success": 200
                    }
                  </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.uploadImage = !accordion.uploadImage"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Upload image'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.uploadImage"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/image/upload HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: multipart/form-data;
                    Content-Disposition: form-data; name="file" {base64 image file}
                    Content-Disposition: form-data; name="name" {name of the image} (optional)
                    Content-Disposition: form-data; name="folder_id" {folder_id} (optional)
                  </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "image": {
                          "extension": "png",
                          "folder_id": "4",
                          "name": "cWr_1610427400_imagename",
                          "url": "https://app.imgforce.com/images/user/cWr_1610427400_imagename"
                      },
                      "success": 200
                    }
                  </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.deleteImage = !accordion.deleteImage"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Delete image'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.deleteImage"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/image/delete HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    id={integer}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "deleted": true,
                      "success": 200
                    }
                </code>
                </pre>
            </div>
          </transition>
        </div>
      </template>
    </flexi-wrapper>

    <flexi-wrapper
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[2].sections[1]"
    >
      <template v-slot:content>
        <div class="accordion-wrapper">
          <div
            @click="accordion.getFolders = !accordion.getFolders"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Get all folders'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.getFolders"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    GET /api/v1/folders/get HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "folders": [
                          {
                              "id": 1,
                              "name": "Default",
                              "created_at": null,
                              "updated_at": null
                          },
                          {
                              "id": 4,
                              "name": "New folder",
                              "created_at": null,
                              "updated_at": null
                          }
                      ],
                      "success": 200
                    }
                </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="
              accordion.getFoldersWithImages = !accordion.getFoldersWithImages
            "
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Get all folders with images'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.getFoldersWithImages"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    GET /api/v1/folders/get-with-images HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                </code>
               </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "folders": [
                          {
                              "id": 1,
                              "name": "Default",
                              "created_at": null,
                              "updated_at": null,
                              "images": [
                                  {
                                    "id": 37,
                                    "folder_id": 1,
                                    "img": "https://app.imgforce.com/images/user/1xI.png",
                                    "imgName": "1xI_1610431744_Akrinum-4.png",
                                    "extension": "png",
                                    "created_at": "2021-01-12T06:09:04.000000Z",
                                    "updated_at": "2021-01-12T06:09:04.000000Z"
                                  },
                                  {
                                    "id": 38,
                                    "folder_id": 1,
                                    "img": "https://app.imgforce.com/images/user/Ylc.png",
                                    "imgName": "Ylc_1610462473_defaultName.png",
                                    "extension": "png",
                                    "created_at": "2021-01-12T14:41:13.000000Z",
                                    "updated_at": "2021-01-12T14:41:13.000000Z"
                                  }
                              ]
                          },
                          {
                              "id": 4,
                              "name": "some folder name",
                              "created_at": null,
                              "updated_at": null,
                              "images": []
                          }
                      ],
                      "success": 200
                    }
                </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.getFolder = !accordion.getFolder"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Get single folder'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.getFolder"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/folder/get HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    id={integer}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "folder": {
                          "id": 1,
                          "name": "Default",
                          "created_at": null,
                          "updated_at": null,
                          "images": [
                              {
                                "id": 37,
                                "folder_id": 1,
                                "img": "https://app.imgforce.com/images/user/1xI.png",
                                "imgName": "1xI_1610431744_Akrinum-4.png",
                                "extension": "png",
                                "created_at": "2021-01-12T06:09:04.000000Z",
                                "updated_at": "2021-01-12T06:09:04.000000Z"
                              },
                              {
                                "id": 38,
                                "folder_id": 1,
                                "img": "https://app.imgforce.com/images/user/Ylc.png",
                                "imgName": "Ylc_1610462473_defaultName.png",
                                "extension": "png",
                                "created_at": "2021-01-12T14:41:13.000000Z",
                                "updated_at": "2021-01-12T14:41:13.000000Z"
                              }
                          ]
                      }
                    }
                </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.createFolder = !accordion.createFolder"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Create new folder'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.createFolder"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/folder/create HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    name={string}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "folder": {
                          "id": 6,
                          "name": "New folder name",
                          "updated_at": "2021-01-12T15:44:47.000000Z",
                          "created_at": "2021-01-12T15:44:47.000000Z",
                      },
                      "created": true
                    }
                </code>
                </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.renameFolder = !accordion.renameFolder"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Rename folder'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.renameFolder"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/folder/rename HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    id={integer}
                    name={string}
                </code>
                </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "new_folder_name": "Renamed folder",
                      "renamed": true
                    }
                </code>
               </pre>
            </div>
          </transition>
          <div class="separator mb-5" />
        </div>

        <div class="accordion-wrapper">
          <div
            @click="accordion.deleteFolder = !accordion.deleteFolder"
            class="accordion-wrapper__header"
          >
            <h6 class="small-header" v-text="'Delete folder'" />
          </div>
          <transition
            name="acc"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <div
              v-if="accordion.deleteFolder"
              class="accordion-wrapper__content"
              key="content"
            >
              <pre class="request">
                <code>
                    POST /api/v1/folder/delete HTTP/1.1
                    Host: app.imgforce.com
                    Accept: application/json
                    Authorization: Bearer {your_token}
                    Content-Type: application/x-www-form-urlencoded
                    id={integer}
                </code>
               </pre>
              <h6 class="small-header" v-text="'Successful response'" />
              <pre class="response">
                <code>
                    {
                      "deleted": true,
                      "success": 200
                    }
                </code>
                </pre>
            </div>
          </transition>
        </div>
      </template>
    </flexi-wrapper>

    <flexi-advanced-last-card
      v-if="inputData.homePage"
      :inputData="inputData.homePage.last_card"
      :navigationPages="inputData.navigationPages"
      :loadingForm="loading"
      @button-clicked="sendNewsEmail"
      data-aos="fade-up"
    >
      <template v-slot:navigation>
        <ul class="navigation-bottom">
          <li
            v-for="(value, key) in bottomNavigation"
            :key="key"
            class="navigation__item"
          >
            <a
              :href="value.href"
              :target="
                value.name === 'Home' || value.name === 'API Documentation'
                  ? ''
                  : '_blank'
              "
            >
              <span v-text="value.name" />
            </a>
          </li>
        </ul>
      </template>
    </flexi-advanced-last-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bottomMenu } from "../static/data/bottomMenu";
import FlexiAdvancedLastCard from "../components/FlexiAdvancedLastCard.vue";

export default {
  name: "api-documentation",
  components: {
    FlexiAdvancedLastCard
  },
  computed: {
    ...mapGetters(["inputData"])
  },
  data() {
    return {
      bottomNavigation: bottomMenu,
      accordion: {
        getImages: false,
        getSingleImage: false,
        uploadImage: false,
        deleteImage: false,
        getFolders: false,
        getFoldersWithImages: false,
        getFolder: false,
        createFolder: false,
        renameFolder: false,
        deleteFolder: false
      }
    };
  },
  methods: {
    beforeEnter(el) {
      el.style.height = "0";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
    },
    enter(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave(el) {
      el.style.height = "0";
    }
  },
  mounted() {
    window.scrollTo(0, 5);
  }
};
</script>

<style lang="scss">
// @import "~@schnapsterdog/flexi-vue/src/assets/scss/parts/_media-mixins";
</style>
